module.exports = __webpack_public_path__ + "img/msi_50rr.893d909a.svg";